/* eslint-disable react-compiler/react-compiler  -- required*/
'use client';
import noop from 'lodash/noop';
import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { useRegistryContext } from '../../../context/RegistryProvider';
import { InterfaceAppStoreContext } from '../context';
import { useInterfaceStoreImperativeHandle } from '../hooks/useInterfaceStoreImperativeHandle';
import { createInterfaceStore } from './createInterfaceStore';
import { createInterfaceStoreSelectors } from './selectors';
import type { InterfaceRunnerStoreProviderProps } from './types';

export function InterfaceAppStoreProvider({
  value,
  children,
  interfaceStoreRef,
}: PropsWithChildren<InterfaceRunnerStoreProviderProps>) {
  const { registry } = useRegistryContext();

  const [store] = useState(() => {
    const interfaceStoreHook = createInterfaceStore(value, {
      updateBlockState: noop,
      registry,
    });

    return createInterfaceStoreSelectors(interfaceStoreHook);
  });

  useInterfaceStoreImperativeHandle({
    interfaceStoreRef,
    store,
  });

  return (
    <InterfaceAppStoreContext.Provider value={store}>{children}</InterfaceAppStoreContext.Provider>
  );
}
